import { Modules } from '../../../util/modules'
import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

// Estimates App
const EstimatesDashboardApp = () => import('@/pmd/pages/payments/EstimatesDashboard.vue')
const EstimatesEditorApp = () =>  import('@/pmd/pages/payments/EstimatesEditor.vue')
const EstimatesTemplateApp = () =>  import('@/pmd/pages/payments/EstimatesTemplate.vue')

export const estimatesRoutes: RouteConfig[] = [
    {
        path: 'payments/v2/estimates/edit/:id',
        name: 'estimates-editor',
        component: EstimatesEditorApp,
        beforeEnter: requireAuthAndLocation,
        meta: {
            hideSideBar: true,
            hideTopBar: true,
            translations: [Modules.Payments],
        },
        children: [],
    },
    {
        path: 'payments/v2/estimates/templates/edit/:id',
        name: 'estimates-template-editor',
        component: EstimatesTemplateApp,
        beforeEnter: requireAuthAndLocation,
        meta: {
            hideSideBar: true,
            hideTopBar: true,
            translations: [Modules.Payments],
        },
        children: [],
    },
    {
        path: 'payments/v2/estimates',
        name:'estimates',
        component:  EstimatesDashboardApp,
        beforeEnter: requireAuthAndLocation,
        children: []
    }
]